import React from 'react'
import { func, bool, string } from 'prop-types'
import emailValidator from 'email-validator'
import {
  PASSWORD_RESET_TITLE,
  PASSWORD_RESET_MESSAGE,
  PASSWORD_RESET_ERROR_MESSAGE,
  RETURN_TO_LOGIN,
  REQUEST_PASSWORD_ACTION
} from '../../constants/ui.labels'
import {
  Base,
  ContentHeader,
  PasswordResetForm,
  CheckEmail,
  Error,
  NavbarButton,
  SecureForm,
  NoRecaptchaSecureForm
} from '../../components'
import { default as redirectToLogin } from '../../utils/redirect/redirectTo'
import { isAutomationAccount } from '../../config/feature-flags'

class PasswordReset extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      isValid: false
    }
  }

  handleEmailChange = ({ target }) => {
    const email = target.value

    this.setState({
      email,
      isValid: emailValidator.validate(email)
    })
  }

  onFormSubmit = recaptchaResponse => {
    const { email } = this.state
    const { onSubmit } = this.props

    onSubmit({
      email,
      recaptchaResponse: recaptchaResponse
    })
  }

  render() {
    const {
      processed,
      error,
      siteKey,
      disabledForm,
      onExecuteRecaptcha
    } = this.props
    const { email, isValid } = this.state

    return (
      <Base.Centered
        navbarActionElement={
          <NavbarButton
            action={redirectToLogin}
            actionMessage={RETURN_TO_LOGIN}
          />
        }
      >
        {!processed ? (
          <React.Fragment>
            <ContentHeader
              title={PASSWORD_RESET_TITLE}
              message={PASSWORD_RESET_MESSAGE}
            />
            <Error message={error ? PASSWORD_RESET_ERROR_MESSAGE : null} />
            <PasswordResetForm
              onEmailValidation={emailValidator.validate}
              email={email}
              onEmailChange={this.handleEmailChange}
              disabledForm={disabledForm}
            />
            {!isAutomationAccount() && siteKey !== '' ? (
              <SecureForm
                isFormValid={isValid}
                siteKey={siteKey}
                disabledForm={disabledForm}
                submitLabel={REQUEST_PASSWORD_ACTION}
                onSubmit={this.onFormSubmit}
                onExecuteRecaptcha={onExecuteRecaptcha}
              />
            ) : (
              <NoRecaptchaSecureForm
                isFormValid={isValid}
                disabledForm={disabledForm}
                submitLabel={REQUEST_PASSWORD_ACTION}
                onSubmit={this.onFormSubmit}
              >
                <React.Fragment></React.Fragment>
              </NoRecaptchaSecureForm>
            )}
          </React.Fragment>
        ) : (
          <CheckEmail />
        )}
      </Base.Centered>
    )
  }
}

PasswordReset.propTypes = {
  onSubmit: func.isRequired,
  onExecuteRecaptcha: func.isRequired,
  siteKey: string.isRequired,
  isAutomationAccount: bool,
  error: bool.isRequired,
  processed: bool.isRequired,
  disabledForm: bool.isRequired
}

export default PasswordReset
